import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import FirstView from '../views/FirstView.vue'
import PhoneNumberView from '../views/PhoneNumberView.vue'
import InsertCodeView from '../views/InsertCodeView.vue'
import IntroView from '../views/IntroView.vue'
import IntroSecondView from '../views/IntroSecondView.vue'
import IntroThirdView from '../views/IntroThirdView.vue'
import IntroFourthView from '../views/IntroFourthView.vue'
import RegisterView from '../views/RegisterView.vue'
import RuleTutorialView from '../views/RuleTutorialView.vue'
import ExamRuleView from '../views/ExamRuleView.vue'
import FaqView from '../views/FaqView.vue'
import FinalExamRuleView from '../views/FinalExamRuleView.vue'
import CompleteFormView from '../views/CompleteFormView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: FirstView
  },
  {
    path: '/PhoneNumber',
    name: 'PhoneNumberView',
    component: PhoneNumberView
  },
  {
    path: '/InsertCode',
    name: 'InsertCodeView',
    component: InsertCodeView,
    props: true
  },
  {
    path: '/final',
    name: 'final',
    component: HomeView
  },
  {
    path: '/intro',
    name: 'intro',
    component: IntroView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/final-exam-rule',
    name: 'final-exam-rule',
    component: FinalExamRuleView
  },
  {
    path: '/complete-form',
    name: 'complete-form',
    component: CompleteFormView
  },
  {
    path: '/rule-tutorial',
    name: 'rule-tutorial',
    component: RuleTutorialView
  },
  {
    path: '/faq',
    name: 'faq',
    component: FaqView
  },
  {
    path: '/exam-rule',
    name: 'exam-rule',
    component: ExamRuleView
  },
  {
    path: '/introSecond',
    name: 'introSecond',
    component: IntroSecondView
  },
  {
    path: '/introThird',
    name: 'introThird',
    component: IntroThirdView
  },
  {
    path: '/introFourth',
    name: 'introFourth',
    component: IntroFourthView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/introSecond',
    name: 'introSecond',
    component: IntroSecondView
  },
  {
    path: '/introThird',
    name: 'introThird',
    component: IntroThirdView
  },
  {
    path: '/introFourth',
    name: 'introFourth',
    component: IntroFourthView
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
